var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-2 v-text-field__details"},[_c('div',{staticClass:"v-messages theme--light",class:{ 'error--text': _vm.error },attrs:{"role":"alert"}},[_c('div',{staticClass:"v-messages__wrapper"},[_c('div',{staticClass:"v-messages__message"},[_vm._v(_vm._s(_vm.$slots.default[0].text))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }